'use es6';

import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import LessRolling from '../../filterQueryFormat/operator/LessRolling';
import GreaterRolling from '../../filterQueryFormat/operator/GreaterRolling';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueRollingInequality = ({
  operator,
  getIsUngated
}) => {
  const key = `customerDataFilters.DisplayValueRollingInequality.${operator.direction}`;
  const zoneInfo = operator.zoneId ? ` (${I18n.moment.tz(undefined, operator.zoneId).format('z')})` : '';
  if (typeof operator.numberOfDays !== 'number') {
    return null;
  }
  const showTimeFormat = (() => {
    const {
      hasTimezones
    } = operator;
    if (!hasRemoveTimezoneForDates(getIsUngated) || operator.field && operator.field.type !== DATE || operator.constructor !== LessRolling && operator.constructor !== GreaterRolling) {
      return true;
    }
    return hasTimezones;
  })();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: key,
    options: {
      count: operator.numberOfDays,
      zoneInfo: showTimeFormat ? zoneInfo : ''
    }
  });
};
DisplayValueRollingInequality.propTypes = {
  getIsUngated: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired
};
export default DisplayValueRollingInequality;